
import { defineComponent, PropType } from 'vue'

export interface Dialog {
  title: string
  message: string
  confirmText: string
  cancelText: string

  isOpen: boolean
}

export default defineComponent({
  name: 'BaseDialog',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true
    }
  },
  setup(props, context) {
    const closeDialog = () => {
      context.emit('closeDialog')
    }

    const onConfirm = () => {
      context.emit('onConfirm')
    }

    return {
      closeDialog,
      onConfirm
    }
  }
})
